import React from 'react'

const SvgExtendedRevisions = props => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="currentColor" {...props}>
    <path d="M12 14v1.88h11.276V14H12zm0 3.759v1.88h11.276v-1.88H12zm16.952.122a.522.522 0 00-.367.16l-.94.94 1.927 1.926.94-.94a.5.5 0 000-.724l-1.203-1.202a.501.501 0 00-.357-.16zM27.1 19.525l-5.704 5.695v1.935h1.935l5.695-5.703-1.926-1.927zM12 21.517v1.88h7.517v-1.88H12z" />
  </svg>
)

export default SvgExtendedRevisions
